import { render, staticRenderFns } from "./Supporter.vue?vue&type=template&id=52ba61f8&"
import script from "./Supporter.vue?vue&type=script&lang=js&"
export * from "./Supporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ba61f8')) {
      api.createRecord('52ba61f8', component.options)
    } else {
      api.reload('52ba61f8', component.options)
    }
    module.hot.accept("./Supporter.vue?vue&type=template&id=52ba61f8&", function () {
      api.rerender('52ba61f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supporters/views/Supporter.vue"
export default component.exports